(function () {
  'use strict';

  var doc = document;
  var $ = function (sel, root) { return (root || doc).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };

  /* ---------- Product: variants, gallery, tabs ---------- */
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/, parts.join('.'));
  }

  function initProduct(root) {
    var info = $('[data-product-info]', root);
    if (!info) return;

    // Gallery thumbnails
    var gallery = $('[data-gallery]', root);
    if (gallery) {
      $$('[data-thumb]', gallery).forEach(function (btn) {
        btn.addEventListener('click', function () { showMedia(gallery, btn.getAttribute('data-media-id')); });
      });
    }
    function setBadge(el, cls, text) {
      var badge = document.createElement('span');
      badge.className = cls;
      badge.textContent = text;
      el.replaceChildren(badge);
    }
    function showMedia(g, id) {
      if (!id) return;
      $$('.product__media', g).forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-media-id') === String(id)); });
      $$('[data-thumb]', g).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(id)); });
    }

    // Donor count is independent of the size picker: a Default Title product has no
    // size select, but still has quantity + Individual donors.
    (function bindDonorCount() {
      var form = $('[data-product-form]', info);
      var qtyInput = form ? $('input[name="quantity"]', form) : $('input[name="quantity"]', info);
      var donorInput = form ? $('[data-donor-count]', form) : $('[data-donor-count]', info);
      if (!donorInput) return;
      function syncDonorCount() {
        var qty = parseInt(qtyInput && qtyInput.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        donorInput.max = String(qty);
        var n = parseInt(donorInput.value, 10);
        if (isNaN(n) || n < 1) n = 1;
        if (n > qty) n = qty;
        donorInput.value = String(n);
      }
      // change, not input: an in-progress qty edit ("") must not snap donors back to 1
      if (qtyInput) qtyInput.addEventListener('change', syncDonorCount);
      donorInput.addEventListener('change', syncDonorCount);
      if (form) form.addEventListener('submit', syncDonorCount);
      syncDonorCount();
    })();

    // Variant picker
    var picker = $('[data-variant-picker]', info);
    var select = $('[data-variant-select]', info);
    var jsonEl = $('[data-variants-json]', info);
    if ((picker || select) && jsonEl) {
      var variants = [];
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }
      var form = $('[data-product-form]', info);
      var idInput = form ? $('[data-variant-id]', form) : null;
      var addBtn = $('[data-add-to-cart]', info);
      var addText = $('[data-add-text]', info);
      var skuEl = $('[data-sku-value]', info);
      var catalogCodes = {};
      var catalogJson = $('[data-catalog-codes]', info);
      if (catalogJson) { try { catalogCodes = JSON.parse(catalogJson.textContent); } catch (e) { catalogCodes = {}; } }
      // no size chosen: the product's own code (the stem every size shares, rendered by Liquid), never a dash
      var productCode = (skuEl && skuEl.getAttribute('data-product-code')) || '';
      function shownCode(v) {
        if (!v) return productCode || '\u2014';
        return catalogCodes[String(v.id)] || v.sku || '\u2014';
      }
      // the legacy part number line: the size's own part number once chosen, the product's base number before
      var legacyRow = $('[data-legacy-row]', info);
      var legacyEl = $('[data-legacy-value]', info);
      var productLegacy = (legacyRow && legacyRow.getAttribute('data-product-legacy')) || '';
      var legacyCodes = {};
      var legacyJson = $('[data-legacy-codes]', info);
      if (legacyJson) { try { legacyCodes = JSON.parse(legacyJson.textContent); } catch (e) { legacyCodes = {}; } }
      function renderLegacy(v) {
        if (!legacyRow) return;
        var code = v ? legacyCodes[String(v.id)] : productLegacy;
        legacyRow.hidden = !code;
        if (legacyEl) legacyEl.textContent = code || '';
      }
      // one "i" on the product code covers both lines: hover / focus shows it, click pins it (the FAQ link stays reachable), Escape closes
      $$('[data-code-info]', info).forEach(function (btn) {
        var tip = document.getElementById(btn.getAttribute('aria-describedby'));
        if (!tip) return;
        var pinned = false, overTip = false, timer = null;
        function show(on) { tip.hidden = !on; btn.setAttribute('aria-expanded', on ? 'true' : 'false'); }
        function leave() { clearTimeout(timer); timer = setTimeout(function () { if (!pinned && !overTip) show(false); }, 150); }
        btn.addEventListener('mouseenter', function () { clearTimeout(timer); show(true); });
        btn.addEventListener('mouseleave', leave);
        btn.addEventListener('focus', function () { show(true); });
        btn.addEventListener('blur', function () { if (!pinned) show(false); });
        btn.addEventListener('click', function () { pinned = !pinned; show(pinned); });
        btn.addEventListener('keydown', function (e) { if (e.key === 'Escape') { pinned = false; show(false); } });
        tip.addEventListener('mouseenter', function () { overTip = true; clearTimeout(timer); });
        tip.addEventListener('mouseleave', function () { overTip = false; leave(); });
      });
      var priceWrap = $('[data-price-wrapper]', info);
      var avail = $('[data-availability]', info);
      var quotes = $$('[data-quote-link], [data-sample-link]', info);
      var leadMap = {};
      var leadJson = $('[data-lead-times]', info);
      if (leadJson) { try { leadMap = JSON.parse(leadJson.textContent); } catch (e) { leadMap = {}; } }
      var leadVal = $('[data-lead-value]', info);
      var leadPrefix = $('[data-lead-prefix]', info);
      var strings = (window.theme && window.theme.strings) || {};
      // labelled line total beside the unit price once the quantity is above 1 (review: "price doesn't
      // update with quantity"; 9.18: "5 x $37.00 = $185.00" read as odd -> "Total (5 x 1 mL)" over the amount)
      var totalEl = $('[data-line-total]', info);
      var totalLabel = $('[data-line-total-label]', info);
      var totalAmount = $('[data-line-total-amount]', info);
      var strTotal = (priceWrap && priceWrap.getAttribute('data-str-total')) || 'Total';
      var qtyInput = form ? $('input[name="quantity"]', form) : $('input[name="quantity"]', info);
      var currentVariant = null;
      function renderTotal() {
        if (!totalEl) return;
        var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
        var show = currentVariant && currentVariant.price > 0 && qty > 1;
        totalEl.hidden = !show;
        if (!show) return;
        var size = currentVariant.title && currentVariant.title !== 'Default Title' ? currentVariant.title : '';
        if (totalLabel) {
          // the "(5 x 1 mL)" part keeps its case: unit symbols are case-sensitive (mL, not ML)
          totalLabel.textContent = strTotal + ' ';
          var qtySpan = document.createElement('span');
          qtySpan.className = 'buybox__amount-qty';
          qtySpan.textContent = '(' + qty + (size ? ' \u00d7 ' + size : '') + ')';
          totalLabel.appendChild(qtySpan);
        }
        if (totalAmount) totalAmount.textContent = formatMoney(currentVariant.price * qty);
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', renderTotal);
        qtyInput.addEventListener('input', renderTotal);
      }

      function selectedOptions() {
        var opts = [];
        if (!picker) return opts;
        $$('fieldset', picker).forEach(function (fs, i) {
          var checked = fs.querySelector('input:checked');
          opts[i] = checked ? checked.value : null;
        });
        return opts;
      }
      function findVariant(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function render(v) {
        currentVariant = v || null;
        renderTotal();
        if (!v) {
          if (addBtn) { addBtn.disabled = true; }
          if (addText) addText.textContent = strings.addToCart || 'Add to Order';
          if (skuEl) skuEl.textContent = shownCode(null);
          renderLegacy(null);
          return;
        }
        if (idInput) idInput.value = v.id;
        if (skuEl) skuEl.textContent = shownCode(v);
        renderLegacy(v);
        if (priceWrap) {
          var from = $('.price__from', priceWrap);
          if (from) from.hidden = true; // "From $x" only while no size is chosen
          var cur = $('.price__current', priceWrap);
          if (cur) {
            var inquire = !v.price;
            cur.textContent = inquire ? (strings.inquire || 'Inquire for Pricing') : formatMoney(v.price);
            cur.classList.toggle('price__inquire', inquire);
          }
          var cmp = $('.price__compare', priceWrap);
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(v.compare_at_price); }
          var p = $('.price', priceWrap);
          if (p) p.classList.toggle('price--on-sale', !!onSale);
        }
        // $0 = "Inquire for Pricing" (Magento carry-over): never let it into the cart as a free line.
        var buyable = v.available && v.price > 0;
        // fresh mode (product-config.js setFreshMode) keeps the button locked across size changes
        if (addBtn) { addBtn.setAttribute('data-fresh-unbuyable', buyable ? '' : '1'); addBtn.disabled = !buyable || addBtn.hasAttribute('data-fresh-locked'); }
        if (addText) addText.textContent = buyable ? (strings.addToCart || 'Add to cart') : !v.price ? (strings.inquire || 'Inquire for Pricing') : (strings.soldOut || 'Sold out');
        if (avail) setBadge(avail, v.available ? 'in-stock' : 'out-of-stock', v.available ? (strings.inStock || 'In stock') : (strings.soldOut || 'Sold out'));
        // Request Sample only for the sizes Magento flagged (data-sample-variants; product-level flag = every size)
        $$('[data-sample-variants]', info).forEach(function (s) {
          var allowed = (s.getAttribute('data-sample-variants') || '').split(',').filter(Boolean);
          s.hidden = allowed.indexOf(String(v.id)) < 0;
        });
        quotes.forEach(function (q) {
          // Liquid rendered the full quote / sample URL (?product=…&sku=…[&bulk=1|&sample=1]); only the sku changes per variant.
          var u = new URL(q.href, window.location.origin);
          u.searchParams.set('sku', v.sku || '');
          q.href = u.href;
        });
        if (leadVal) {
          var lead = leadMap[v.id] || leadMap[String(v.id)] || '';
          leadVal.textContent = lead;
          if (leadPrefix) leadPrefix.hidden = lead.indexOf('On hand') === 0;
        }
        if (gallery && v.featured_media && v.featured_media.id) showMedia(gallery, v.featured_media.id);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      // the variant the page opened with (?variant=, a single-size product): the line total needs its price
      var initialId = String((select && select.value) || (idInput && idInput.value) || '');
      for (var vi = 0; vi < variants.length; vi++) { if (String(variants[vi].id) === initialId) { currentVariant = variants[vi]; break; } }
      if (!currentVariant && variants.length === 1) currentVariant = variants[0];
      renderTotal();
      if (picker) picker.addEventListener('change', function () { render(findVariant(selectedOptions())); });
      if (select) {
        select.addEventListener('change', function () {
          var id = String(select.value), v = null;
          for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === id) { v = variants[i]; break; } }
          render(v);
        });
      }
    }

  }

  window.theme.register(function (root) {
    initProduct(root);
  });
})();
